import WFacebookCommentComponent from '@wix/thunderbolt-elements/src/components/WFacebookComment/viewer/WFacebookComment';
import WFacebookCommentController from '@wix/thunderbolt-elements/src/components/WFacebookComment/viewer/WFacebookComment.controller';


const WFacebookComment = {
  component: WFacebookCommentComponent,
  controller: WFacebookCommentController
};


export const components = {
  ['WFacebookComment']: WFacebookComment
};

